import React, { useState } from 'react';
import { Row, Col, Typography, List, Space, Dropdown, Menu, Button, Modal } from 'antd';
import Background from '../../../../../static/img/bg-list-title.png';
import Client from '../../../../../lib/gqlClient';
import { syncReveiwToJira, UpdateReviewStatus } from '../gqls'
import { useNavigate } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { message } from 'antd'
const CommentsItemPage = (props) => {

    const { Paragraph, Text } = Typography;
    const navigate = useNavigate();

    //Model弹窗
    const [jiraSyncModelproject, setJiraSyncModelproject] = useState([{ key: 0, label: 'MyVitals4' },])
    const [jiraSyncModelIssueType, setjiraSyncModelIssueType] = useState([{}])
    const [jiraMembersList, setJiraMembersList] = useState([{}])

    const [modalData, setModalData] = useState('Are you sure you want to ignore')
    const [jiraSyncProject, setJiraSyncProject] = useState('MyVitals4')
    const [jiraSyncIssueType, setJiraSyncIssueType] = useState('Select issue type')
    const [JiraMembers, setJiraMembers] = useState('Please select')

    const [openJiraSync, setOpenJiraSync] = useState(false);
    const [openIgnore, setOpenIgnore] = useState(false);

    function onClick(data) {
        navigate('/developerCenter/scoreOrComments/commentsContentData', {
            replace: false,
            state: {
                userName: data.userName,
                score: data.score,
                region: data.region,
                appVersion: data.appVersion,
                createdAt: data.createdAt,
                title: data.title,
                content: data.content,
                replyDate: data.replyDate,
                replyText: data.replyText,
                app: 'MyVitals4.0',
                platform: 'Android',

                ignore: props.ignore,
                version: props.version,

                startTime: props.startTime,
                endTime: props.endTime,
                startTimeString: props.startTimeString,
                endTimeString: props.endTimeString,
                
                page: props.page,
                showSize: props.showSize,
            }
        })
    }

    function onShowJiraSyncModal(item) {
        if (item.status === 'IGNORE' || item.jiraId !== null) {
            return
        }
        var list = [{}]
        props.jira.map((item, index) => {
            list[index] = { key: index, label: item.projectName }
        })

        setIssueType("MyVitals4")

        var list2 = [{}]
        props.JiraMembers.map((item, index) => {
            list2[index] = {
                key: index,
                label: (
                    <div>
                        <div style={{ fontSize: '14px' }}>{item.name}</div>
                        <div style={{ fontSize: '12px', color: '#BFBFBF' }}>{item.email}</div>
                    </div>)
            }
        })
        setJiraMembersList(list2)

        setOpenJiraSync(true)

    }
    const onQueryZendeskToJira = (data) => {
        let id
        let issueType
        let accountId
        props.jira.map((item, index) => {
            if (item.projectName === jiraSyncProject) {
                id = item.projectId
                item.issueType.map((item1, index) => {
                    if (jiraSyncIssueType === item1.display) {
                        issueType = item1.id
                    }
                })
            }
        })

        props.JiraMembers.map((item) => {
            if (item.email === JiraMembers) {
                accountId = item.accountId
            }
        })
        setOpenJiraSync(false)
        props.setLoding(true)
        Client(
            '',
            {
                syncReveiwToJiraId: data.id,
                platform: 'ANDROID',
                projectId: id,
                issueType: issueType,
                assignTo: accountId
            },
            syncReveiwToJira
        ).then((res) => {
            props.setLoding(false)
            //刷数据
            props.onRefresh()
            if (res != null && res.data.syncReveiwToJira.jiraId !== null) {
                message.success('Sync to Jira successfull')
            } else {
                message.error('Sync to Jira failed')
            }
        }).catch(e => {
            message.error('Sync to Jira failed')
            props.setLoding(false)
            props.onRefresh()
        })
    }

    const itemsJiraSyncProjectClick = ({ key }) => {
        setJiraSyncProject(jiraSyncModelproject[key].label)
    };
    const itemsJiraSyncIssueTypeClick = ({ key }) => {
        setJiraSyncIssueType(jiraSyncModelIssueType[key].label)
    };
    const itemsJiraMembersClick = ({ key }) => {
        console.log(key, props.JiraMembers[key])
        setJiraMembers(props.JiraMembers[key].email)
    };
    function onShowIgnoreModal(data) {
        if (data.status === 'IGNORE') {
            setModalData('Are you sure you want to unignore')
        } else {
            setModalData('Are you sure you want to ignore')
        }
        setOpenIgnore(true)
    }
    const onHideIgnoreModal = (data) => {
        setOpenIgnore(false)
        props.setLoding(true)
        Client(
            '',
            {
                updateReviewStatusId: data.id,
                status: data.status === "IGNORE" ? "New" : "IGNORE",
                platform: 'ANDROID'
            },
            UpdateReviewStatus
        ).then((res) => {
            //刷数据
            props.setLoding(false)
            props.onRefresh()
            if (res != null) {
                if (res.data.updateReviewStatus.status === 'IGNORE') {
                    message.success('Ignore successfully')
                } else if (res.data.updateReviewStatus.status === 'New') {
                    message.success('Unignore successfully')
                }

            } else {
                if (data.status === 'IGNORE') {
                    message.error('Unignore failed')
                } else if (data.status === 'New') {
                    message.error('Ignore failed')
                }
            }
        }).catch(e => {
            message.error('Network timeout, please try again')
            props.setLoding(false)
            props.onRefresh()
        })
    }
    function setIssueType(name) {
        var list1 = [{}]
        props.jira.map((item, index) => {
            if (item.projectName === name) {
                item.issueType.map((item1, index1) => {
                    list1[index1] = { key: index1, label: item1.display }
                })
            }
        })
        setjiraSyncModelIssueType(list1);
        setJiraSyncIssueType('Select issue type');
    }
    return (
        <List.Item>
            <Row style={Styles.item}>
                <Col span={3} style={Styles.listTitleText}>
                    {props.item.userName}
                </Col>
                <Col span={2} style={Styles.listTitleText}>
                    {props.item.score}
                </Col>
                <Col span={2} style={Styles.listTitleText}>
                    {props.item.region}
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    {props.item.appVersion}
                </Col>
                <Col span={6} style={Styles.listTitleText}>
                    {props.item.content}
                </Col>
                <Col span={4} style={Styles.listTitleText}>
                    {props.item.createdAt.substring(0, 10)}
                </Col>
                <Col span={3} style={Styles.listTitleText}>
                    <a onClick={() => onClick(props.item)} style={{ color: '#2657F9' }}>
                        <Space>
                            View
                        </Space>
                    </a>
                    <a onClick={() => onShowJiraSyncModal(props.item)}>
                        <div style={{ color: (props.item.status === 'IGNORE' || props.item.jiraId !== null) ? 'rgba(0, 0, 0, 0.25)' : '#2657F9' }}>
                            Jira Sync
                        </div>
                    </a>
                    <Modal
                        closable={false}
                        centered
                        open={openJiraSync}
                        footer={null}
                        width={441}
                        destroyOnClose={true}
                        maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                        bodyStyle={{ padding: '0px', width: '441px', background: 'ffffff', borderRadius: '10px' }}
                        style={{ borderRadius: "10px", overflow: "auto" }}>

                        <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '66px' }}>Jira Sync</div>
                        <div style={{ height: '1px', width: '441px', background: '#E9E9E9' }}></div>
                        <div style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Project</div>
                        <Dropdown trigger={'click'} overlay={<Menu onClick={itemsJiraSyncProjectClick} items={jiraSyncModelproject} />} style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                            <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                <Space>
                                    <div style={{ fontSize: '14px', color: "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                        {jiraSyncProject}</div>
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>
                        <Space style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Issue Type</Space>
                        <Dropdown trigger={'click'} overlay={<Menu onClick={itemsJiraSyncIssueTypeClick} items={jiraSyncModelIssueType} />} style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                            <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                <Space>
                                    <div style={{ fontSize: '14px', color: jiraSyncIssueType === "Select issue type" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                        {jiraSyncIssueType}</div>
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>
                        <Space style={{ fontSize: '14px', lineHeight: '22px', marginTop: '30px', marginLeft: '67px', }}>Assign to</Space>
                        <Dropdown
                            trigger={'click'}
                            overlay={<
                                Menu onClick={itemsJiraMembersClick}
                                items={jiraMembersList}
                                dropdownRender={(menu) => (
                                    <div className="dropdown-content">
                                        {menu}
                                    </div>
                                )}
                            />}
                            style={{ width: '307px', height: '40px', marginLeft: '67px', marginTop: '6px' }}>
                            <Button style={{ padding: '0px', width: '307px', height: '40px', color: 'rgba(0, 0, 0, 0.25)', marginLeft: '67px', marginTop: '6px' }} >
                                <Space>
                                    <div style={{ fontSize: '14px', color: JiraMembers === "Please select" ? "rgba(0, 0, 0, 0.25)" : "#000", width: '260px', height: '40px', display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                        {JiraMembers}</div>
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>
                        <Row style={{ marginTop: '30px', paddingBottom: '30px', marginRight: '67px', display: 'flex', justifyContent: 'right' }}>
                            <Col>
                                <Button onClick={() => setOpenJiraSync(false)} style={{ fontSize: '14px', width: '80px', height: '32px' }}>取消</Button>
                            </Col>
                            <Col>
                                <Button onClick={() => onQueryZendeskToJira(props.item)} style={{ fontSize: '14px', background: '#FF5300', color: 'white', width: '80px', height: '32px', marginLeft: '14px' }}>创建</Button>
                            </Col>
                        </Row>
                    </Modal>
                    <a onClick={() => onShowIgnoreModal(props.item)}>
                        <Space style={{ color: props.item.status === 'IGNORE' ? 'rgba(0, 0, 0, 0.25)' : '#D61B1B' }}>
                            Ignore
                        </Space>
                    </a>
                    <Modal
                        closable={false}
                        centered
                        open={openIgnore}
                        footer={null}
                        width={320}
                        destroyOnClose={true}
                        maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                        bodyStyle={{ padding: '0px', width: '320px', background: 'ffffff', borderRadius: '10px' }}
                        style={{ borderRadius: "10px", overflow: "auto" }}
                    >
                        <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '112px' }}>
                            <div>
                                <div >{modalData} </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>this ticket？</div>

                            </div>
                        </div>

                        <div style={{ height: '1px', width: '320px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                        <Row>
                            <Col span={'159.5px'}>
                                <Button type="text" onClick={() => setOpenIgnore(false)} style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: '16px', width: '159.5px', height: '56px' }}>Cancel</Button>
                            </Col>
                            <Col span={'1px'}>
                                <div style={{ height: '56px', width: '1px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                            </Col>
                            <Col span={'159.5px'}>
                                <Button type="text" onClick={() => onHideIgnoreModal(props.item)} style={{ fontSize: '16px', width: '159.5px', height: '56px' }}>Yes</Button>
                            </Col>
                        </Row>

                    </Modal>
                </Col>
            </Row>
        </List.Item>
    );

}

const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
    },
    item: {
        minEight: '54px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}
export default CommentsItemPage